var Vue = require('vue');
var InterfaceText = require('./components/InterfaceText.vue').default;

module.exports = function() {
  new Vue({
    el: '#interface-text',
    components: {
      'interface-text': InterfaceText
    }
  });
};
